export const contactsData = {
    email: 'dnyaneshwarmagar276@gmail.com',
    phone: '+917972895724',
    address: 'Pune, Maharashtra ',

    sheetAPI: 'https://sheetdb.io/api/v1/a8sg4ugk7wqqf'
}
